import { Injectable } from '@angular/core';
import {
  GetActionsParams,
  IsActionAvailableParams,
  IsTelegramAttachAllParams,
  TableAction
} from "../types/table-actions.types";

@Injectable({
  providedIn: 'root'
})
export class TableActionsService {
  public getActions(getActionsParams: GetActionsParams): Array<TableAction> {
    const { tableActions, resourcePath, record } = getActionsParams;
    const actions: Array<TableAction>  = [
      {
        type: 'TELEGRAM_ATTACH_ALL',
        color: 'primary',
        icon: 'add_link',
        condition: this.isTelegramAttachAll({
          resourcePath,
          record
        })
      },
      {
        type: 'CHANGE_USER_PASSWORD',
        color: 'primary',
        icon: 'password',
        condition: this.isActionAvailable({
          tableActions: tableActions,
          action: 'CHANGE_USER_PASSWORD'
        })
      },
      {
        type: 'BLOGGER_DEDUPLICATION',
        color: 'warn',
        icon: 'merge',
        condition: this.isActionAvailable({
          tableActions: tableActions,
          action: 'BLOGGER_DEDUPLICATION'
        })
      },
      {
        type: 'DELETE_ROW',
        color: 'warn',
        icon: 'delete_outline',
        condition: this.isActionAvailable({
          tableActions: tableActions,
          action: 'DELETE_ROW'
        })
      }
    ];

    return actions.filter(action => action.condition);
  }

  private isActionAvailable({ tableActions, action }: IsActionAvailableParams): boolean {
    return tableActions.includes(action);
  }

  private isTelegramAttachAll({ resourcePath, record }: IsTelegramAttachAllParams): boolean {
    return resourcePath === 'users' && !!record['telegram'];
  }
}
